import React, { useState } from "react";
import Loading from "../Loadings/LoadingTable";

import { Table } from "../Table/Table";
import { months } from "../../data/yearMonth";
import { useGetUserRollCallList } from "../../hooks/useManagement";
import { SimpleSelect1 } from "../SimpleSelect/SimpleSelect1";

const RollCallListUser = () => {
  const [month, setMonth] = useState();
  const [Search, setSearch] = useState("");
  const { data, isLoading, refetch } = useGetUserRollCallList({ month });
  const monthOptions = months.map((item) => {
    return { value: item.value, label: item.label };
  });
  const RollCallHeader = [
    "ردیف",
    "نام و نام خانوادگی",
    "ساعت ورود",
    "ساعت خروج",
    "تاریخ",
    "مرخصی",
    "ماه",
    "کاهش یا افزایش",
  ];
  const items = data?.data?.map((item, index) => {
    return (
      <tr key={index}>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {index + 1}
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            <span>
              {(item?.user?.FirstName ? item?.user?.FirstName : "") +
                " " +
                (item?.user?.LastName ? item?.user?.LastName : "")}
            </span>
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {item?.StartHours}
          </span>
        </td>

        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {item?.EndHours}
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            <span className={`text-muted fw-bold text-muted d-block fs-7`}>
              {item?.DateShamciHours}
            </span>
          </span>
        </td>

        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {item?.Leave === 0 ? "بدون مرخصی" : item?.Leave}
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {item?.MonthHours}
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {item?.sum}
          </span>
        </td>
      </tr>
    );
  });
  return (
    <>
      <div className="inputs row m-0 mt-3">
        <div className="col-lg-3 col-12">
          <SimpleSelect1
            label="انتخاب ماه"
            res={monthOptions}
            onChange={(e) => {
              setMonth(e.value);
              refetch();
            }}
          />
        </div>
      </div>
      <Table
        className="mt-3"
        setSearch={setSearch}
        headerTitle={RollCallHeader}
        items={!isLoading ? items : <Loading />}
        title={`لیست حضور و غیاب ${items?.length}`}
      />
    </>
  );
};

export default RollCallListUser;
